

class CartImgProductSelected extends HTMLElement {
  constructor() {
    super()
  }
  productData;
  connectedCallback() {
    this.productData = this.getElementsByTagName("product-parts-data").item(0);
    if (this.productData.dataLoaded) {
      this.initView();
    } else this.productData.addEventListener("dataLoaded", this.initView.bind(this))

  }
  disconnectedCallback() {
    // this.productData?.removeEventListener("dataLoaded", this.initView.bind(this));
  }
  getSelected() {
    var strSelected = this.dataset.selected || '';
    var arrSelected = strSelected.split(",").map(el => el.trim());
    return arrSelected;
  }
  initView() {

    var selected = this.getSelected();
    var parts = selected.map(element => this.productData.getPartValue(element)).filter(elFt => elFt != undefined).sort((el1, el2) => el1.order - el2.order);

    if (parts.length == 0) {
      var elImg = document.createElement("img");
      elImg.src = this.dataset.defaultimg;
      this.appendChild(elImg);
    }
    for (let index = 0; index < parts.length; index++) {
      const element = parts[index];
      var elImg = document.createElement("img");
      elImg.src = element.view3;
      this.appendChild(elImg);
    }
  }
}

if (!customElements.get('img-product-selected')) customElements.define('img-product-selected', CartImgProductSelected);
